import './EmailPreview.scss';
import { AgxRow, AgxTypography } from '@urbanx/agx.ui-components2';

interface EmailPreviewProps {
  templateContent: string;
}

const EmailPreview = ({ templateContent }: EmailPreviewProps) => {
  return (
    <div className="agx-email-preview-container">
      <AgxRow gap={'spacing-xl'} alignItems="alignCenter" justifyContent="space-between">
        <AgxTypography id="email-preview" type="label" size="medium">
          Email Preview
        </AgxTypography>
        <AgxTypography id="read-only" type="caption" size="small">
          Read only
        </AgxTypography>
      </AgxRow>

      <pre className="agx-email-preview-content">{templateContent}</pre>
    </div>
  );
};

export default EmailPreview;
